import { memo } from 'react';

import DateTimeIcon from '@/assets/date-change-icon.svg?react';
import { merge } from '@/components';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type DateLogoProps = VariantLogoProps;

const IDateLogo = ({ className, ...rest }: DateLogoProps) => {
  return (
    <FormatterValidatorLogo Icon={DateTimeIcon} className={merge('bg-teal-50 text-teal-700', className)} {...rest} />
  );
};

export const DateLogo = memo(IDateLogo) as typeof IDateLogo;
